export default "__VITE_ASSET__BNkd0NK8__"